import React, { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { connect, useDispatch } from 'react-redux';
// import { useHistory } from "react-router-dom";
// import axios from 'axios';
import EditIcon from "@material-ui/icons/Edit"
// import styles from "assets/css/argon-dashboard-react.css"
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { handleTheme, handleText } from 'pages/redux/actions';
import { Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Media, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col, } from "reactstrap";

const options = [
    { key: 'dark', label: 'Dark' },
    { key: 'white', label: 'Light' },
    { key: 'darkpurple', label: 'Dark Purple' },
];

const Sidebar = (props) => {
    // console.log('hello')
    // console.log(props.theme)
    // console.log(props.text)

    const dispatch = useDispatch();
    const [open2, setOpen2] = React.useState(false);
    const fetchData = React.useCallback(() => {
        
    }, [])
    React.useEffect(() => {
        fetchData()
    }, [fetchData])

    // const [anchorEl, setAnchorEl] = React.useState < null | HTMLElement > (null);
    let [anchorEl, setAnchorEl] = React.useState();
    // const open2 = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen2(true)
    };

    const handleClose2 = () => {
        // setAnchorEl(null);
        setOpen2(false)
    };

    const handleChangeTheme = (event) => {
        console.log(event.target.id)
        if (event.target.id === 'dark') {
            dispatch(handleText('white'))
            dispatch(handleTheme('dark'))
        }
        else if (event.target.id === 'white') {
            dispatch(handleText('darkp'))
            dispatch(handleTheme('white'))
        }
        else if (event.target.id === 'darkpurple') {
            dispatch(handleText('white'))
            dispatch(handleTheme('darkpurple'))
        }
        else {
            console.log('no')
        }
        setOpen2(false)
    };

    const [collapseOpen, setCollapseOpen] = useState();
    const toggleCollapse = () => {
        setCollapseOpen((data) => !data);
    };
    const [about, setabout] = useState(true);
    // closes the collapse
    const closeCollapse = () => {
        setCollapseOpen(false);
    };
    const aboutopen = () => {
        setabout(!about);
    };
    // creates the links that appear in the left menu / Sidebar
    const createLinks = (routes) => {
        return (
            <>
                <NavItem key='1'>
                    <NavLink
                        to='/info/overview'
                        tag={NavLinkRRD}
                        onClick={closeCollapse}
                        activeClassName={"textbg-" + props.theme}
                        className={"texts-" + props.theme}
                    >
                        Overview
                    </NavLink>
                </NavItem>
                <NavItem key='1'>
                    <NavLink
                        to='/info/about'
                        tag={NavLinkRRD}
                        onClick={aboutopen}
                        activeClassName={"textbg-" + props.theme}
                        className={"texts-" + props.theme}
                    >
                        About
                    </NavLink>
                </NavItem>
                <Collapse isOpen={about}>
                <NavItem key='1' >
                    <div href="#main" className="bg-greenc full-width">
                        <a
                            href='#main'
                            style={{fontSize:'13px'}}
                            className={"ml-4 full-width bg-yellowc full-height pt-2 pb-2 pl-6 texts-" + props.theme}>
                            - Main
                        </a>
                    </div>
                </NavItem>
                <NavItem key='1' >
                    <div href="#application" className="bg-greenc full-width">
                        <a
                            href='#application'
                            style={{ fontSize: '13px' }}
                            className={"ml-4 full-width bg-yellowc full-height pt-2 pb-2 pl-6 texts-" + props.theme}>
                            - Application
                    </a>
                    </div>
                </NavItem>
                <NavItem key='1' >
                    <div href="#usage" className="bg-greenc full-width">
                        <a
                            href='#usage'
                            style={{ fontSize: '13px' }}
                            className={"ml-4 full-width bg-yellowc full-height pt-2 pb-2 pl-6 texts-" + props.theme}>
                            - Usage
                    </a>
                    </div>
                </NavItem>
                </Collapse>
            </>
        )
    };

    const { routes, logo } = props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
        navbarBrandProps = {
            to: logo.innerLink,
            tag: Link,
        };
    } else if (logo && logo.outterLink) {
        navbarBrandProps = {
            href: logo.outterLink,
            target: "_blank",
        };
    }
    return (
        <Navbar
            className={"navbar-vertical fixed-left navbar-light sbg-" + props.theme}
            expand="md"
            id="sidenav-main"
        >
            <Container fluid className="bg-orancge">
                {/* Toggler */}
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                >
                    {/* <span className={"navbar-toggler-icon texts-" + props.theme} /> */}
                    <i className={"ni ni-bullet-list-67 texts-" + props.theme}></i>
                </button>
                {/* Brand */}
                {logo ? (
                    <NavbarBrand className="pt-0 bg-yellovw" {...navbarBrandProps}>
                        <img
                            alt={logo.imgAlt}
                            className="navbar-brand-img"
                            src={logo.imgSrc}
                            style={{ marginTop: '20px', height: '100px !important' }}
                        />
                    </NavbarBrand>
                ) : null}
                {/* User */}
                <Nav className="align-items-center d-md-none">
                    <UncontrolledDropdown nav>
                        <DropdownToggle nav className="nav-link-icon">
                            <i className="ni ni-bell-55" />
                        </DropdownToggle>
                        <DropdownMenu
                            aria-labelledby="navbar-default_dropdown_1"
                            className="dropdown-menu-arrow"
                            right
                        >
                            <DropdownItem>Action</DropdownItem>
                            <DropdownItem>Another action</DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem>Something else here</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <UncontrolledDropdown nav>
                        <DropdownToggle nav>
                            <Media className="align-items-center">
                                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" className={"bgp-" + props.theme + " text-" + props.theme}>u</Avatar>
                            </Media>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem className="noti-title" header tag="div">
                                <h6 className="text-overflow m-0">Welcome!</h6>
                            </DropdownItem>
                            <DropdownItem to="/admin/user-profile" tag={Link}>
                                <i className="ni ni-single-02" />
                                <span>My profile</span>
                            </DropdownItem>
                            <DropdownItem to="/admin/user-profile" tag={Link}>
                                <EditIcon className="ni" />
                                <span>Edit Profile</span>
                            </DropdownItem>
                            <DropdownItem to="/admin/user-profile" tag={Link}>
                                <i className="ni ni-settings-gear-65" />
                                <span>Settings</span>
                            </DropdownItem>
                            <DropdownItem to="/admin/user-profile" tag={Link}>
                                <i className="ni ni-calendar-grid-58" />
                                <span>Activity</span>
                            </DropdownItem>
                            <DropdownItem to="/admin/user-profile" tag={Link}>
                                <i className="ni ni-support-16" />
                                <span>Support</span>
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem href="/auth/logout">
                                <i className="ni ni-button-power" />
                                <span>Logout</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <div>
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            className={"ml-0 textb-" + props.theme}
                            disableRipple
                            onClick={handleClick}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            open={open2}
                            anchorEl={anchorEl}
                            onClose={handleClose2}
                            style={{ paddingTop: '0px !important', backgroundColor: 'transparent !important' }}
                        >
                            {options.map((option) => (
                                <MenuItem key={option.key} className={"lbg-" + props.theme + ' texts-' + props.theme} id={option.key} selected={option.key === props.theme} onClick={handleChangeTheme}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                </Nav>
                {/* Collapse */}
                <Collapse navbar className={"sbg-" + props.theme} isOpen={collapseOpen}>
                    {/* Collapse header */}
                    <div className="navbar-collapse-header d-md-none">
                        <Row>
                            {logo ? (
                                <Col className="collapse-brand" xs="6">
                                    {logo.innerLink ? (
                                        <Link to={logo.innerLink}>
                                            <img alt={logo.imgAlt} src={logo.imgSrc} />
                                        </Link>
                                    ) : (
                                        <a href={logo.outterLink}>
                                            <img alt={logo.imgAlt} src={logo.imgSrc} />
                                        </a>
                                    )}
                                </Col>
                            ) : null}
                            <Col className="collapse-close" xs="6">
                                <button
                                    className={"navbar-toggler texts-" + props.theme}
                                    type="button"
                                    onClick={toggleCollapse}
                                >
                                    <i className={"ni ni-fat-add texts-" + props.theme}></i>
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* Navigation */}
                    <Nav navbar>{createLinks(routes)}</Nav>
                    {/* Divider */}
                    <hr className="my-3" />
                    {/* Heading */}
                    <h6 className="navbar-heading text-muted">Informational</h6>
                    {/* Navigation */}
                    <Nav className={"mb-md-3 sbg-" + props.theme} navbar>
                        <NavItem>
                            <NavLink href="#">
                                {/* <i className="ni ni-spaceshipx" /> */}
                Help
              </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#">
                                {/* <i className="ni ni-palettex" /> */}
                Manual
              </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#">
                                {/* <i className="ni ni-ui-04x" /> */}
                Complaints
              </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    );
};

Sidebar.defaultProps = {
    routes: [{}],
};

Sidebar.propTypes = {
    // links that will be displayed inside the component
    routes: PropTypes.arrayOf(PropTypes.object),
    logo: PropTypes.shape({
        // innerLink is for links that will direct the user within the app
        // it will be rendered as <Link to="...">...</Link> tag
        innerLink: PropTypes.string,
        // outterLink is for links that will direct the user outside the app
        // it will be rendered as simple <a href="...">...</a> tag
        outterLink: PropTypes.string,
        // the image src of the logo
        imgSrc: PropTypes.string.isRequired,
        // the alt for the img
        imgAlt: PropTypes.string.isRequired,
    }),
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
    }
}

export default connect(mapStateToProps)(Sidebar);
